/**
 * Проверка валидности пароля
 * @param {string} password - проверяемый пароль
 * @returns {boolean} - true если пароль валиден
 */
export const isValidPassword = (password) => {
  if (!password || password.trim() === "") return false;

  if (password.length < 8) return false;

  const latinRegex = /^[A-Za-z0-9]+$/;
  if (!latinRegex.test(password)) return false;

  const hasLetter = /[A-Za-z]/.test(password);
  const hasDigit = /\d/.test(password);

  return hasLetter && hasDigit;
};

/**
 * Получение сообщения об ошибке для пароля
 * @param {string} password - проверяемый пароль
 * @returns {string|null} - сообщение об ошибке или null
 */
export const getPasswordErrorMessage = (password) => {
  if (!password || password.trim() === "") {
    return null;
  }

  if (password.length < 8) {
    return "Пароль должен содержать не менее 8 символов";
  }

  const latinRegex = /^[A-Za-z0-9]+$/;
  if (!latinRegex.test(password)) {
    return "Пароль должен содержать только латинские буквы и цифры";
  }

  const hasLetter = /[A-Za-z]/.test(password);
  if (!hasLetter) {
    return "Пароль должен содержать хотя бы одну букву";
  }

  const hasDigit = /\d/.test(password);
  if (!hasDigit) {
    return "Пароль должен содержать хотя бы одну цифру";
  }

  return null;
};

/**
 * Проверка совпадения паролей
 * @param {string} password - пароль
 * @param {string} confirmedPassword - подтверждение пароля
 * @returns {boolean} - true если пароли совпадают
 */
export const isPasswordMatch = (password, confirmedPassword) => {
  return password === confirmedPassword;
};

/**
 * Получение сообщения об ошибке для подтверждения пароля
 * @param {string} password - пароль
 * @param {string} confirmedPassword - подтверждение пароля
 * @returns {string|null} - сообщение об ошибке или null
 */
export const getConfirmedPasswordErrorMessage = (
  password,
  confirmedPassword,
) => {
  if (!confirmedPassword || confirmedPassword.trim() === "") {
    return null;
  }

  if (!isPasswordMatch(password, confirmedPassword)) {
    return "Пароли не совпадают";
  }

  return null;
};
